import * as Sentry from '@sentry/react';
import { initSentry } from './utils/sentry';

initSentry('dao-admin');

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { stashDeepLink } from './services/deep-link-store';
import './index.css';

// bl-714: capture the entry deep-link BEFORE React mounts (and therefore before
// the auth gate can redirect an unauthenticated admin to the hosted login
// front-door). On the post-login `?code=` return, the pre-mount code→JWT bootstrap
// (services/identity-code-bootstrap) restores it. Skips root + `?code=` returns
// internally; best-effort.
stashDeepLink();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>An error occurred. Please reload the page.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
